module.exports = __webpack_public_path__ + "static/joinus1-6a2f60e65d99aae68ef743bde4ba3744.jpeg";